export const MAILER_TEMPLATES = {
	RESERVATION: {
		GUEST: {
			CONFIRMED: 'reservation_guest_confirmed',
			PENDING: 'reservation_guest_pending',
			UPDATED: 'reservation_guest_updated',
			CANCELLED: 'reservation_guest_cancelled',
		},
		OWNER: {
			NEW: 'reservation_owner_new',
			UPDATED: 'reservation_owner_updated',
			CANCELLED: 'reservation_owner_cancelled',
		},
		REMINDER: {
			MINIMAL: 'reservation_reminder-minimal',
		},
		REVIEW: {
			MINIMAL: 'reservation_review-minimal',
		},
		FEEDBACK: {
			MINIMAL: 'reservation_feedback-minimal',
		},
	},
	AUTH: {
		EMAIL_CONFIRMATION: {
			DEFAULT: 'auth_email_confirmation-default',
		},
		NEW_USER_PASSWORD: {
			DEFAULT: 'auth_new_user_password-default',
		},
		RESET_PASSWORD: {
			DEFAULT: 'auth_reset_password-default',
		},
	},
}
